<template>
    <div class="case_card card_bottom-padding caseInfo">
        <el-row class="title_row">
            <el-col :span="12">
                <div class="card_title">
                    投诉案件详情
                    <el-tag type="warning" style="margin-left: 5px" v-if="caseDetailData && caseDetailData.suspendedFlag">挂起</el-tag>
                </div>
            </el-col>
        </el-row>
        <div class="card_content">
            <el-row>
                <el-col :span="24">
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7" v-if="editInfoType == 2">投诉编号： <el-input class="inputNo" maxlength="50" v-model="editForm2.complaintNumber"></el-input> </el-col>
                        <el-col class="col_txt" :span="7" v-else>投诉编号：{{ caseDetailData && caseDetailData.complaintNumber ? caseDetailData.complaintNumber : '--' }}</el-col>
                        <!-- @blur="queryPolicyInfo" -->
                        <el-col class="col_txt" :span="7" :offset="2" v-if="editInfoType == 1"
                            >保单号：
                            <el-form class="checkForm" ref="editFormRef1" :model="editForm" :rules="editFormRules1" label-width="0">
                                <el-form-item prop="policyNo">
                                    <el-input class="inputNo" maxlength="50" v-model="editForm.policyNo" @change="queryPolicyInfo"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="2" v-else>保单号：{{ caseDetailData && caseDetailData.policyNo ? caseDetailData.policyNo : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-if="editInfoType == 1 || editInfoType == 2"
                            >案件号：
                            <el-form class="checkForm" ref="editFormRef1" :model="editForm" :rules="editFormRules1" label-width="0">
                                <el-form-item prop="caseNo">
                                    <el-input class="inputNo" maxlength="50" v-model="editForm.caseNo"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-else>案件号：{{ caseDetailData && caseDetailData.caseNo ? caseDetailData.caseNo : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7" v-if="editInfoType == 2">
                            渠道：
                            <el-select style="width: 200px !important" v-model="editForm2.complaintChannel" filterable clearable placeholder="请选择">
                                <el-option v-for="item in channelOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="col_txt" :span="7" v-else>渠道：{{ caseDetailData && caseDetailData.complaintChannel ? caseDetailData.complaintChannel : '--' }}</el-col>
                        <!-- <el-col class="col_txt" :span="7" :offset="2" v-if="editInfoType == 1">保单号：<el-input class="inputNo" maxlength="50" v-model="editForm.policyNo" @change="queryPolicyInfo"></el-input></el-col> -->
                        <el-col class="col_txt" :span="7" :offset="2" v-if="editInfoType == 1">投诉人：<el-input class="inputNo" maxlength="20" v-model="editForm.complaintPerson"></el-input></el-col>
                        <el-col class="col_txt" :span="7" :offset="2" v-else>投诉人：{{ caseDetailData && caseDetailData.complaintPerson ? caseDetailData.complaintPerson : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-if="editInfoType == 2">
                            投诉人身份：
                            <el-select style="width: 200px !important" v-model="editForm2.complaintIdCard" clearable placeholder="请选择">
                                <el-option v-for="item in complaintIdCardOptions" :key="item.id" :label="item.dictName" :value="item.dictName"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-else>
                            投诉人身份：{{ caseDetailData && caseDetailData.complaintIdCard ? caseDetailData.complaintIdCard : '--' }}
                            <span v-if="caseDetailData && caseDetailData.complaintIdCard == '其他'">- {{ caseDetailData.complaintIdCardRemark ? caseDetailData.complaintIdCardRemark : '--' }}</span>
                        </el-col>
                    </el-row>
                    <el-row class="content_row" v-if="editInfoType == 2 && editForm2.complaintIdCard == '其他'">
                        <el-col class="col_txt" :span="7" :offset="9">身份备注：<el-input class="inputNo" style="margin-left: 15px" maxlength="50" v-model="editForm2.complaintIdCardRemark"></el-input> </el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7">处理人：{{ caseDetailData && caseDetailData.assistingHandler ? caseDetailData.assistingHandler : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="2">投诉电话1：{{ caseDetailData && caseDetailData.complaintPhone ? caseDetailData.complaintPhone : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="1">投诉电话2：{{ caseDetailData && caseDetailData.complaintPhone2 ? caseDetailData.complaintPhone2 : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7">责任机构：{{ caseDetailData && caseDetailData.liableOrganization ? caseDetailData.liableOrganization : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="2" v-if="editInfoType == 2 || editInfoType == 1"
                            >骑手姓名：
                            <el-form class="checkForm" ref="editFormRef1" style="width: calc(100% - 65px)" :model="editForm" :rules="editFormRules1" label-width="0">
                                <el-form-item prop="riderName">
                                    <el-input class="inputNo" maxlength="50" v-model="editForm.riderName"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="2" v-else>骑手姓名：{{ caseDetailData && caseDetailData.riderName ? caseDetailData.riderName : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-if="editInfoType == 2 || editInfoType == 1"
                            >骑手身份证：
                            <el-form class="checkForm" ref="editFormRef1" style="width: calc(100% - 75px)" :model="editForm" :rules="editFormRules1" label-width="0">
                                <el-form-item prop="riderIdCard">
                                    <el-input class="riderInput" maxlength="50" v-model="editForm.riderIdCard"></el-input>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-else>骑手身份证：{{ caseDetailData && caseDetailData.riderIdCard ? caseDetailData.riderIdCard : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row" v-if="editInfoType == 2">
                        <el-col class="col_txt" :span="24"
                            >投诉内容：
                            <el-input v-model="editForm2.complaintContent" type="textarea" :rows="3" maxlength="1000" placeholder="请输入内容"> </el-input>
                        </el-col>
                    </el-row>
                    <el-row class="content_row" v-else>
                        <el-col class="col_txt" :span="24">投诉内容：{{ caseDetailData && caseDetailData.complaintContent ? caseDetailData.complaintContent : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7">投诉原因：{{ caseDetailData && caseDetailData.complaintCause ? caseDetailData.complaintCause : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="2">具体争议：{{ caseDetailData && caseDetailData.specificDisputes ? caseDetailData.specificDisputes : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7">涉诉机构：{{ caseDetailData && caseDetailData.complaintOrganization ? caseDetailData.complaintOrganization : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="2">责任人：{{ caseDetailData && caseDetailData.liablePerson ? caseDetailData.liablePerson : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="1">核赔人：{{ caseDetailData && caseDetailData.checkIndemnityPerson ? caseDetailData.checkIndemnityPerson : '--' }}</el-col>
                    </el-row>
                    <el-row class="content_row">
                        <el-col class="col_txt" :span="7" v-if="editInfoType == 1"
                            >涉诉省：
                            <el-select class="inputNo" v-model="editForm.province" filterable clearable placeholder="请选择" @change="enterProvinceChange">
                                <el-option v-for="item in provinceOptions" :key="item.areaName" :label="item.areaName" :value="item.areaName"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="col_txt" :span="7" v-else>涉诉省：{{ caseDetailData && caseDetailData.province ? caseDetailData.province : '--' }}</el-col>

                        <el-col class="col_txt" :span="7" :offset="2" v-if="editInfoType == 1"
                            >涉诉市：
                            <el-select class="inputNo" v-model="editForm.city" filterable clearable placeholder="请选择">
                                <el-option v-for="item in cityOptions" :key="item.areaName" :label="item.areaName" :value="item.areaName"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="2" v-else>涉诉市：{{ caseDetailData && caseDetailData.city ? caseDetailData.city : '--' }}</el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-if="editInfoType == 2">
                            升级情况：
                            <el-select style="width: 200px !important" v-model="editForm2.upgradeSituation" filterable clearable placeholder="请选择">
                                <el-option v-for="(item, index) in upgradeOptions" :key="index" :label="item.dictName" :value="item.dictName"> </el-option>
                            </el-select>
                        </el-col>
                        <el-col class="col_txt" :span="7" :offset="1" v-else>升级情况：{{ caseDetailData && caseDetailData.upgradeSituation ? caseDetailData.upgradeSituation : '--' }}</el-col>
                        <!-- <el-col class="col_txt" :span="7" :offset="1">是否结案：{{ caseDetailData && String(caseDetailData.closeCaseFlag) == 'true' ? '是' : caseDetailData && String(caseDetailData.closeCaseFlag) == 'false' ? '否' : '--' }}</el-col> -->
                    </el-row>
                    <el-form ref="editFormRef" :model="editForm" :rules="editFormRules" label-width="100px">
                        <template v-if="editInfoType == 1">
                            <el-row class="content_row" style="margin-bottom: 0">
                                <el-col class="col_txt" :span="7"
                                    >争议案件：
                                    <el-radio v-model="editForm.disputedCase" :label="true">是</el-radio>
                                    <el-radio v-model="editForm.disputedCase" :label="false">否</el-radio>
                                </el-col>
                                <el-col class="col_txt" :span="7" :offset="2">
                                    <el-form-item class="formStyle" label="索赔金额:" prop="claimAmount">
                                        <el-input
                                            class="inputNo"
                                            v-model="editForm.claimAmount"
                                            placeholder="请输入内容"
                                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(\d)/, '$1')"
                                        >
                                        </el-input>
                                        元
                                    </el-form-item>
                                </el-col>
                                <el-col class="col_txt" :span="7" :offset="1">
                                    <el-form-item class="formStyle1" label="争议金额:" prop="disputedAmount">
                                        <el-input
                                            class="edit_input"
                                            v-model="editForm.disputedAmount"
                                            placeholder="请输入内容"
                                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '').replace(/^0+(\d)/, '$1')"
                                        >
                                        </el-input>
                                        元
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                        <template v-else>
                            <el-row class="content_row">
                                <el-col class="col_txt" :span="7">争议案件：{{ caseDetailData && String(caseDetailData.disputedCase) == 'true' ? '是' : caseDetailData && String(caseDetailData.disputedCase) == 'false' ? '否' : '--' }}</el-col>
                                <el-col class="col_txt" :span="7" :offset="2">索赔金额：{{ caseDetailData && caseDetailData.claimAmount ? caseDetailData.claimAmount : '--' }} 元</el-col>
                                <el-col class="col_txt" :span="7" :offset="1">争议金额：{{ caseDetailData && caseDetailData.disputedAmount ? caseDetailData.disputedAmount : '--' }} 元</el-col>
                            </el-row>
                        </template>
                        <el-row class="content_row" v-if="editInfoType == 1">
                            <el-col class="col_txt" :span="24">
                                <el-form-item class="formStyle" label="备注:" prop="submitRemark">
                                    <el-input v-model="editForm.submitRemark" type="textarea" :rows="3" placeholder="请输入内容"> </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="content_row" v-else>
                            <el-col class="col_txt" :span="24">备注：{{ caseDetailData && caseDetailData.remark ? caseDetailData.remark : '--' }}</el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        caseDetailData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        btnMenuData: {
            type: Object,
            default: null
        },
        editInfoFlag: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            editForm: {
                disputedCase: false,
                claimAmount: '',
                complaintPerson: '',
                disputedAmount: '',
                submitRemark: '',
                policyNo: '',
                caseNo: ''
            },
            editForm2: {
                complaintNumber: '',
                complaintChannel: '',
                complaintIdCard: '',
                complaintIdCardRemark: '',
                complaintContent: '',
                upgradeSituation: ''
            },
            editFormRules1: {
                policyNo: [
                    { required: false, message: '请输入保单号', trigger: 'blur' },
                    {
                        pattern: /^[A-Za-z0-9]*$/, // 正则：只允许字母和数字
                        message: '仅支持输入字母和数字',
                        trigger: ['blur', 'change'] // 失焦和输入变化时都校验
                    }
                ],
                riderName: [
                    { required: false, message: '请输入骑手姓名', trigger: 'blur' },
                    {
                        pattern: /^[\u4e00-\u9fa5a-zA-Z]+([·\u00A0-\uFFFF\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]*[\u4e00-\u9fa5a-zA-Z]+)*$/, // 正则：中英文符号只能在文字中间
                        message: '仅支持输入中文、英文，且符号只能在中间',
                        trigger: ['blur', 'change'] // 失焦和输入变化时都校验
                    }
                ],
                riderIdCard: [
                    { required: false, message: '请输入骑手身份证号', trigger: 'blur' },
                    {
                        pattern: /(^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$)|(^[1-9]\d{5}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}$)/,
                        message: '请输入正确的身份证号',
                        trigger: ['blur', 'change']
                    }
                ]
            },
            provinceOptions: [],
            cityOptions: [],
            editInfoType: null,
            channelOptions: [],
            complaintIdCardOptions: [],
            upgradeOptions: []
        };
    },
    computed: {
        editFormRules() {
            let tmpRules = {
                claimAmount: [{ required: true, message: '请输入', trigger: ['change', 'blur'] }],
                disputedAmount: [{ required: true, message: '请输入', trigger: ['change', 'blur'] }],
                submitRemark: [{ required: true, message: '请输入', trigger: ['change', 'blur'] }]
            };

            if (!this.editForm.disputedCase) {
                tmpRules = {
                    claimAmount: [{ required: false, message: '请输入', trigger: ['change', 'blur'] }],
                    disputedAmount: [{ required: false, message: '请输入', trigger: ['change', 'blur'] }],
                    submitRemark: [{ required: true, message: '请输入', trigger: ['blur'] }]
                };
            }

            this.$forceUpdate();

            return tmpRules;
        }
    },
    mounted() {
        this.findProvince();
        // 获取渠道
        this.getPublicEnum('COMPLAINT_CHANNEL_INFO', 'channelOptions');
        // 投诉人身份
        this.getPublicEnum('COMPLAINT_ID_CARD', 'complaintIdCardOptions');
        // 获取升级情况
        this.getPublicEnum('COMPLAINT_UPGRADE_SITUATION', 'upgradeOptions');
    },
    methods: {
        // 查询保单信息
        queryPolicyInfo() {
            this.instance.post('/complaintInfo/findExistsComplaint', { policyNo: this.editForm.policyNo }).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.setEditData(data.data);
                }
            });
        },
        findProvince() {
            this.instance.post('/area/findProvince', {}).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data) {
                    this.provinceOptions = data.data;
                }
            });
        },
        findCity() {
            return;
            let code = this.addCaseForm.province.split('-')[1];
            this.instance.post('/area/findCity/' + code, {}).then((res) => {
                let data = res.data;
                if (data.code == 1 && data.data) {
                    this.cityDisabled = false;
                    this.districtDisabled = false;
                    this.cityOptions = data.data;
                }
            });
        },
        enterProvinceChange(val) {
            this.editForm.city = '';
            this.findCityChange();
        },
        findCityChange() {
            this.instance.post('/area/findCityName/' + this.editForm.province, {}).then((res) => {
                let data = res.data;
                if (data.code == 1) {
                    this.cityOptions = data.data;
                }
            });
        },
        editCaseDetail(update, event, parentData) {
            if (!parentData) {
                this.$emit('getEditDetailForm', 1, parentData);
                return;
            }

            this.$refs.editFormRef1.validate((valid) => {
                if (valid) {
                    let editFormData = {};
                    if (this.editInfoType == 2) {
                        // 咨诉岗编辑
                        editFormData = { ...this.editForm2, ...parentData, ...this.editForm, remark: this.editForm.submitRemark };
                    } else {
                        // 处理岗编辑
                        editFormData = { ...parentData, ...this.editForm, remark: this.editForm.submitRemark };
                    }

                    this.$refs.editFormRef.validate((valid) => {
                        if (valid) {
                            this.instance.post('/complaintInfo/editComplaint', editFormData).then((res) => {
                                let data = res.data;
                                if (data.code == 1) {
                                    this.$message.success('编辑成功！');
                                    this.$emit('saveEditInfo', false);
                                } else {
                                    this.$message.error(data.msg);
                                }
                                update && this.$emit('updatePageInfo');
                            });
                        }
                    });
                }
            });
        },
        setEditData(formData) {
            if (!formData) {
                return;
            }

            // 涉诉机构
            // this.editForm.complaintOrganization = formData.complaintOrganization;
            // 责任人
            this.editForm.liablePerson = formData.liablePerson;
            // 升级情况
            this.editForm.upgradeSituation = formData.upgradeSituation;
            // 省
            this.editForm.province = formData.accidentProvince;
            // 市
            setTimeout(() => {
                this.editForm.city = formData.accidentCity;
                this.$forceUpdate();
            }, 100);
        }
    },
    watch: {
        caseDetailData: {
            handler(val) {
                if (val) {
                    this.editForm = {
                        complaintId: val.id,
                        caseNo: val.caseNo,
                        riderName: val.riderName,
                        riderIdCard: val.riderIdCard,
                        disputedCase: val.disputedCase,
                        claimAmount: val.claimAmount,
                        disputedAmount: val.disputedAmount,
                        complaintPerson: val.complaintPerson,
                        complaintOrganization: val.complaintOrganization,
                        closeCaseFlag: val.closeCaseFlag,
                        policyNo: val.policyNo,
                        liablePerson: val.liablePerson,
                        province: val.province,
                        city: val.city,
                        submitRemark: val.remark
                    };
                    this.editForm2 = {
                        complaintNumber: val.complaintNumber,
                        complaintChannel: val.complaintChannel,
                        complaintIdCard: val.complaintIdCard,
                        complaintIdCardRemark: val.complaintIdCardRemark,
                        complaintContent: val.complaintContent,
                        upgradeSituation: val.upgradeSituation
                    };

                    this.findCityChange();
                }
            },
            immediate: true
        },
        editInfoFlag: {
            handler(val) {
                if (this.editInfoFlag) {
                    this.editInfoType = Boolean(this.btnMenuData[302]) ? 2 : 1;
                } else {
                    this.editInfoType = 0;
                }
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/table_public.css';
@import '../../assets/css/caseCard.css';
.caseInfo {
    .title_row {
        .btn_groups {
            text-align: right;
        }
    }
    .card_content {
        .content_row {
            .title {
                font-weight: 600;
            }
            .col_title {
                // font-weight: 600;
                max-width: 80px;
            }
            .col_txt {
                line-height: 22px;
                word-break: break-all;
                // border: 1px solid red;
                .edit_input {
                    width: 160px !important;
                }
                .inputNo {
                    width: 200px !important;
                }
                .riderInput {
                    width: 180px !important;
                }
                .formStyle {
                    margin-left: -48px;
                }
                .formStyle1 {
                    margin-left: -34px;
                }
            }
            .winRate {
                display: inline-block;
                width: 11px;
                height: 11px;
                border-radius: 50%;
                margin-right: 5px;
                position: relative;
                top: 1px;
            }
            .greenColor {
                background: #67c23a;
            }
            .redColor {
                background: red;
            }
        }
    }
    .checkForm {
        width: calc(100% - 52px);
        display: inline-block;
    }
}
</style>